import React from 'react';
import { connect } from 'react-redux'

// Components
import { addPhotoToPool, choosePhoto, bulkAddPhotosToPool } from 'components/collage/CollageSlice.js'
import Dropzone from 'react-dropzone'
import UploaderAd from 'components/misc/UploaderAd.js'

// Firebase
import firebase from 'firebase/app';
import 'firebase/analytics';

// CSS
import './Uploader.css';

// Images
import Photos from 'img/icons/photos.svg';

class Uploader extends React.Component {

  constructor(props) {
    super(props);

    this._numLoaded   = 0;
    this._numDropped  = 0;
  }

  handleOnDrop = async (acceptedFiles) => {

    firebase.analytics().logEvent('dropped_photos');

    let poolObjects = {};
    this._numDropped = acceptedFiles.length;

    for( let i = 0; i < acceptedFiles.length; i++ ) {
   
      let imgObjectURL = URL.createObjectURL(acceptedFiles[i]);

      var image = new Image();
      image.src = imgObjectURL;
      image.onload = (event) => {

        poolObjects[event.target.currentSrc] = {
          src: event.target.currentSrc,
          width: event.target.width /10,
          height: event.target.height /10
        };

        this._numLoaded++;

        if ( this._numLoaded >= this._numDropped ) {
                
          this._numLoaded   = 0;
          this._numDropped  = 0;
      
          this.props.bulkAddPhotosToPool(poolObjects);
        }

      }

    }

  }

  render() {

    let className = ['PhotoUploader'];

    if ( this.props.collage.photos.num ) {
      className.push('PhotoUploader--WithPhotos')
    }

    return (
      <Dropzone 
        onDrop={this.handleOnDrop}
        accept={'image/*'}
      >
        {({getRootProps, getInputProps, isDragActive}) => (
          <section className={className.join(' ')}>
            <div className={'UploadDropzone' + (isDragActive ? ' UploadDropzone--DropActive' : '')} {...getRootProps()}>
              <input {...getInputProps()} />

              {this.props.collage.mode == 'lg' &&
                <div>
                  <img src={Photos} className={'UploadIcon'} />
                  {isDragActive ? <p>Drop 'em right here</p> : <p>Drop unlimited photos here, or click Add Photos</p>}
                </div>
              }
              <button className="Button Button--Photos">Add{this.props.collage.photos.num ? ' More' : ''} Photos</button>
            </div>
            {/*             
            {(this.props.collage.photos.num === 0) &&
              <UploaderAd />
            }
            {(this.props.collage.photos.num === 0) &&
              <UploaderAd />
            }
             */}
          </section>
        )}
      </Dropzone>
    );
  }
}
const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  { addPhotoToPool, choosePhoto, bulkAddPhotosToPool }
)(Uploader)